<template>
<!--<div id="app">
    <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div>
    <router-view/>
  </div>-->
<div id="app">
  <div v-if="alert.message" :class="`alert ${alert.type}`">{{alert.message}}</div>
  <router-view />
</div>
</template>
<script>
import {mapState} from 'vuex'
export default {
  created() {
    let existingCode = localStorage.getItem('promoCode')
    let firstTest = this.$route.query && this.$route.query.promoCode
    if(firstTest) {
      let {promoCode } = this.$route.query
      localStorage.setItem('promoCode',promoCode)
      this.$store.dispatch('promo/getCode',{code:promoCode})
    }
    if(existingCode) {
      this.$store.dispatch('promo/getCode',{code: existingCode})
    }
  },
  mounted() {
    // console.log(this.$store.state.alert)
  },
  mounted() {
   /*this.$intercom.boot({
      // user_id: this.userId,
      // name: this.name,
      // email: this.email,
    });*/
    // this.$intercom.show();
  },
  computed: {
    ...mapState({ // sets to the parent object
      alert: 'alert',
      'auth': 'auth',
    })
  },
  watch: {
    $route(to,from) {
      // console.log(`route changed from ${from.path} to ${to.path}`)

      // clear alert on location change
      this.$store.dispatch('alert/clear')
      window.Intercom('update')

    }
  }
}
</script>
<style lang="stylus">
#app
  font-family Helvetica, Arial, 'Avenir' sans-serif
  -webkit-font-smoothing antialiased
  -moz-osx-font-smoothing grayscale
// #nav
//   padding 30px

.error {
  color: red;
}
</style>
